<template>
  <div v-if="!loading" class="active-challenge-router">
    <active-challenge-summary v-if="isChallengeFinished"/>
    <active-challenge-dashboard v-else-if="isAuthenticatedRoute"/>
    <active-challenge-dashboard-non-customer v-else/>
  </div>
</template>

<script>

import { mapGetters, mapActions, mapMutations, mapState } from 'vuex';
import ActiveChallengeDashboard
  from '@/pages/responsive-pages/authenticated/multiplayer-experience/accountability-group-challenge/ActiveChallengeDashboard';
import ActiveChallengeDashboardNonCustomer
  from '@/pages/responsive-pages/authenticated/multiplayer-experience/accountability-group-challenge/ActiveChallengeDashboardNonCustomer';
import ActiveChallengeSummary
  from '@/pages/responsive-pages/authenticated/multiplayer-experience/accountability-group-challenge/ActiveChallengeSummary';

export default {
  name: 'ActiveChallengeRouter',
  components: {
    ActiveChallengeDashboard,
    ActiveChallengeDashboardNonCustomer,
    ActiveChallengeSummary,
  },
  data() {
    return {
      loading: false,
    };
  },
  props: {
    ownerParticipantId: {
      type: String,
      required: true,
    },
    isAuthenticatedRoute: {
      type: Boolean,
      required: true,
    },
  },
  async created() {
    this.loading = true;
    this.setOwnerParticipantId(this.ownerParticipantId);
    await this.initChallengeDashboard(this.customerId);
    this.loading = false;
  },
  computed: {
    ...mapGetters('accountabilityChallenge', ['isChallengeFinished']),
    ...mapState('session', ['customerId']),
  },
  methods: {
    ...mapActions('accountabilityChallenge', ['initChallengeDashboard']),
    ...mapMutations('accountabilityChallenge', ['setOwnerParticipantId']),
  },
};
</script>

<style lang="scss" scoped>
.active-challenge-router {
  height: 100%;
}
</style>
